import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { getMeds, getMedsHistory, getCurrentUser, resetMedsState, resetMedsHistoryState, setMeds, setMedsHistory } from 'store/storeValtio';
import { getDataAPI, loadDataFromFB, syncData } from 'helpers/apiHelpers';
import { deleteAllTransactionsFromDb } from 'store/localDb';
import { loadFromOriginalFirestore } from './originalFirestore';
import { insertValuesArray } from 'store/idb';
import HelpTitle from 'components/common/HelpTitle';

export default function SyncData() {
  const [error, setError] = useState();
  const [firestoreSync, setFirestoreSync] = useState(false)
  //const [firestoreGet, setFirestoreGet] = useState(false)
  const navigate = useNavigate();
  const currentUser = getCurrentUser();
  console.log("SyncData");

  function sendSync() {
    if ('serviceWorker' in navigator && 'SyncManager' in window) {
      console.log('serviceWorker active');
      navigator.serviceWorker.ready
        .then(function(sw) {
          console.log('navigator.serviceWorker.ready');
          return sw.sync.register('sync-itiw');
        })
        .catch((err) => {
          console.log('sendSync error', err);
        });
    } else {
      console.log('Service Worker NOT ACTIVE, sync not registered');
    }
  }

  async function syncDataToFirestore() {
    console.log('syncDataToFirestore');
    const regId = currentUser.registrationId;
    if (!regId) {
      setError("You must be registered to use this function");
      return;
    }
    setFirestoreSync(true);
    //await syncData('syncUser', currentUser)
    await deleteAllTransactionsFromDb();

    let data = getMeds();
    await getDataAPI('delMeds/' + regId);
    await syncData('saveMeds', data);
    
    data = getMedsHistory();
    await getDataAPI('delHist/' + regId);
    var data25 = [];
    var count = 0;
    for( var ix = 0; ix < data.length; ++ix) {
      data25.push(data[ix]);
      ++count;
      if (count >= 25) {
        await syncData('saveHist', data25);
        data25 = [];
        count = 0;
      }
    }
    if (count > 0) {
      await syncData('saveHist', data25);
    }

    setFirestoreSync(false);
  }

  async function loadDataFromFirestore() {
    console.log('loadDataFromFirestore');
    if (!currentUser.registrationId) {
      setError("You must be registered to use this function");
      return;
    }
    setFirestoreSync(true);
    // this should not do anything, but ???
    await deleteAllTransactionsFromDb();

    resetMedsState()
    const meds = await loadDataFromFB('loadMeds');
    console.log('loadMeds', meds);
    await insertValuesArray('medications', meds);
    setMeds(meds);

    resetMedsHistoryState();
    const hist = await loadDataFromFB('loadHist');
    console.log('loadHist', hist);
    await insertValuesArray('history', hist);
    setMedsHistory(hist);

    setFirestoreSync(false);
    navigate('/');
  }

  // async function getFromOriginalFirestore() {
  //   setFirestoreGet(true);
  //   await loadFromOriginalFirestore();
  //   setFirestoreGet(false);
  // }

  return (
    <div className='pt-8 h-full flex flex-col justify-normal items-center text-center font-bold text-2xl bg-blue-200 '>
      <HelpTitle title="Sync Data" helpSubject="SyncData" />
      <div className='w-8/12 flex flex-col justify-center item-center mt-10 text-xl'>
        {error && (
          <div className='flex justify-center item-center'>
            <div className='p-2 bg-red-300 rounded-md border-2 border-black'>
              {error}
            </div>
          </div>
        )}
        <button
          disabled={firestoreSync}
          onClick={() => syncDataToFirestore()}
          className='selBtn mb-4' >
          Save/update data to Firestore
        </button>
        <button
          disabled={firestoreSync}
          onClick={() => loadDataFromFirestore()}
          className='selBtn mb-4' >
          Load/restore data from Firestore
        </button>
        <button
          onClick={() => process()}
          className='selBtn mb-4' >
          Process Transactions
        </button>
        {/* <button
          onClick={() => getFromOriginalFirestore()}
          disabled={firestoreGet}
          className='selBtn mb-4' >
          Load from Original Firestore
        </button> */}
        <button
          onClick={() => sendSync()}
          className='selBtn mb-4' >
          Send Sync
        </button>
      </div>
    </div>
  )
}

